export const getLanguageFromPath = (path, locales) => {
  const languages = Object.keys(locales);
  if (!path) {
    return languages[0];
  }
  const langPart = path.split("/")[1];
  return languages.includes(langPart) ? langPart : languages[0];
};
